module.exports = __webpack_public_path__ + "img/company_strength_03.41a2adf8.png";